import { Text } from '@trmediaab/zebra';
import { Home } from '@trmediaab/zebra-icons';
import type { CheckoutUserWithAddress } from '@trmediaab/zebra-types/trhub';
import { formatPostalCode } from '@trmediaab/zebra-utils';

import Card from '../../components/Card';
import TextWithAdjacentIcon from '../../components/TextWithAdjacentIcon';

interface AddressInfoProps {
  user: CheckoutUserWithAddress;
}

const AddressInfo = ({ user }: AddressInfoProps) => {
  const {
    firstName,
    lastName,
    address: { address, careOf, postalCode, city },
  } = user;
  return (
    <Card>
      <TextWithAdjacentIcon
        icon={<Home size="18px" color="checkout.icon1" />}
        text="Adressupgifter"
        fontWeight="bold"
      />
      <Text>
        {firstName} {lastName}
      </Text>
      {careOf != null && careOf.length > 0 ? <Text>c/o {careOf}</Text> : null}
      <Text>{address}</Text>
      <Text>
        {formatPostalCode(postalCode)} {city}
      </Text>
    </Card>
  );
};

export default AddressInfo;
